import React from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import { LedgerEntryType } from '../../common/Helpers';
import AccountTag from '../../lib/AccountTag';
import { decodeHex } from '../../common/Helpers';

const PermissionedDomain = (props) => {
    const { node } = props;
    if ( node?.LedgerEntryType === LedgerEntryType.PermissionedDomain ) {
        return (
            <>
                {node?.AcceptedCredentials &&
                <tr>
                    <td>AcceptedCredentials:</td>
                    <td>
                        <Table responsibe>
                           <thead>
                               <tr className='table-primary'>
                                    <th>#</th>
                                    <th>Issuer</th>
                                    <th>CredentialType</th>
                                </tr>
                            </thead>
                            <tbody>
                                {node.AcceptedCredentials.map((acceptedCredential, index) => {
                                    return(
                                        <tr>
                                            <td>{index + 1}</td>
                                            <td><AccountTag link>{acceptedCredential?.Credential?.Issuer}</AccountTag></td>
                                            <td>{decodeHex(acceptedCredential?.Credential?.CredentialType)}</td>
                                        </tr>
                                    )
                                    })
                                }
                                
                            </tbody>
                        </Table>
                    </td>
                </tr>
                }
            </>
        );    
    } else {
        return <></>;
    }
}

PermissionedDomain.propTypes = {
    node: PropTypes.object,
}

export default PermissionedDomain;